import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EmployeeService } from '../../../../../shared/_services/employee.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { StatusModalComponent } from '../../../../modals/status-modal/status-modal.component';
import { Location } from '@angular/common';
import { Subject } from 'rxjs';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { ValidationService } from '../../../../../shared/_services/validation.service';
import { UtilService } from '../../../../../shared/_services/util.service';

@Component({
  selector: 'app-employee-details',
  templateUrl: './employee-details.component.html',
  styleUrls: ['./employee-details.component.scss']
})
export class EmployeeDetailsComponent implements OnInit {

  successMsg: string;
  errorMsg: string;
  employeeForm: FormGroup;
  statusModal: BsModalRef;
  hotels: any[] = [];
  employeeId: number;
  private unsubscribe: Subject<void> = new Subject<void>();
  employeeDetails: any;
  previousRoute: any;
  genderSuffixes: any[] = [];
  constructor(
    private location: Location,
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private utilService: UtilService,
    private modalService: BsModalService,
    private validationService: ValidationService,
    private employeeService: EmployeeService
  ) {
    this.modalService.onHide
    .takeUntil(this.unsubscribe)
    .subscribe(res => {
      if (this.statusModal) {
        if (this.statusModal.content.srcObject.action == "action1") {
          if (this.statusModal.content.srcObject.type == "employee") {
            if (this.statusModal.content.srcObject.status || this.statusModal.content.srcObject.status == 0) {
              let status = +this.statusModal.content.srcObject.status;
              this.activateOrDeactivateEmployee(this.statusModal.content.srcObject.id, status);
            } else {
              this.location.back();
              this.employeeService.employeeDetails = null;
            }
          }
        }
      }
    })
   }

   activateOrDeactivateEmployee(employeeIds, status) {
    console.log(` employee ${JSON.stringify(employeeIds)} was selected to ${status == 0 ? 'Deactivate' : 'Activate'}`)
    this.employeeService.activateOrDeactivateEmployee(employeeIds, status).subscribe(res => {
      if(res.error == 0) {
        this.location.back();
      }
    }, err => {
      console.error('Error Activating/Deactivating Employee: ', err.message);
    }) 
  }

  addEmployee(isReset) {
    this.employeeService.saveOrUpdateEmployee(this.utilService.trimObj(this.employeeForm.value)).subscribe(res => {
      if(res.error == 0) {
        // this.successMsg = res && res.message ? res.message : "Promo added successfully";
        this.successMsg = !this.employeeId ? "Employee has been added successfully" : "Changes made successfully";
        setTimeout(() => {
          this.successMsg = "";
          if (isReset) {
            this.initForm(null);
          } else {
            this.location.back();
            this.employeeService.employeeDetails = null;
          }
      }, 1500);
      }
    },err => {
      this.errorMsg = err && err.message ? err.message : (!this.employeeId ? "Error while creating New Employee" : "Error while updating Employee");
      setTimeout(() => {
        this.errorMsg = "";
      }, 2000);
      console.error('Error while saving/updating benefit data: ', err.message);
    })
  }

  getHotelsByHotelChain() {
    this.employeeService.getHotelsByHotelChain().subscribe(res => {
      if (res.error == 0) {
        this.hotels = res.responseObj;
      }
    }, err => {
      console.error('Error while getting hotel list by hotelchain id: ', err.message);
    })
  }

  getGenderSuffixes() {
    this.employeeService.getGenderSuffixes().subscribe(res => {
      if (res.error == 0) {
        this.genderSuffixes = res.responseObj;
      }
    }, err => {
      console.error('Error while getting hotel list by hotelchain id: ', err.message);
    })
  }

  getEmployeeDetails(employeeId) {
    this.employeeService.getEmployeeById(employeeId).subscribe(res => {
      if(res.error == 0) {
        this.employeeDetails = res.responseObj;
        this.initForm(this.employeeDetails);
      }
    }, err => {
      console.error('Error while fetching employee details by id: ', err.message);
    });
  }

  openStatusModal(id?, mode?) {
    this.statusModal = this.modalService.show(StatusModalComponent, { class: 'confirm-modal' });
    let message = mode == 0 ? "Are you sure you want to deactivate this Employee(s)?" : "Are you sure you want to activate this Employee(s)?";
    let title = mode == 0 ? "Deactivate Employee" : "Activate Employee";
    let action1 = mode == 0 ? "Deactivate" : "Activate";
    let style = mode == 0 ? "inactive" : "active";
    let status = mode;
    this.statusModal.content.srcObject = {
      mode: "custom",
      type: 'employee',
      title: title,
      message: message,
      status,
      id: id,
      action1: action1,
      action2: 'Cancel',
      action: '',
      style: style
    }
  }

  confirmClose() {
    this.statusModal = this.modalService.show(StatusModalComponent, { class: 'confirm-modal' });
    this.statusModal.content.srcObject = {
      mode: 'custom',
      type: 'employee',
      title: 'Confirm',
      message: !this.employeeId ? "Are you sure you want to cancel adding a new Employee?" : "Do you want to cancel modifying the Employee?",
      status: null,
      action1: 'Yes',
      action2: 'No',
      action: '',
    }
  }

  selectedHotel(hotel) {
    this.employeeForm.get('hotelName').setValue(hotel && hotel.hotelName ? hotel.hotelName : null);
    this.employeeForm.get('hotel').setValue(hotel && hotel.hotelId ? hotel.hotelId : null);
  }

  initForm(data?) {
    this.employeeForm = this.fb.group({
      loyaltyMemberId: [data ? data.loyaltyMemberId : ''],
      genderSuffix: [data ? data.genderSuffix : ''],
      firstName: [data ? data.firstName : '', [Validators.required, Validators.maxLength(60), this.validationService.noWhitespaceValidator]],
      // email: [data ? data.email : '', [Validators.required, Validators.pattern(this.validationService.email_regexPattern), this.validationService.noWhitespaceValidator]],
      email: [data ? data.email : '', [Validators.required, this.validationService.noWhitespaceValidator]],
      lastName: [data ? data.lastName : '', [Validators.required, Validators.maxLength(60), this.validationService.noWhitespaceValidator]],
      empCode: [data ? data.empCode : '', [Validators.required, Validators.maxLength(10), this.validationService.noWhitespaceValidator]],
      hotel: [data ? data.hotel : null],
      hotelName: [data ? data.hotelName : '', []],
      department: [data ? data.department : '', [Validators.maxLength(100)]],
      position: [data ? data.position : '', [Validators.maxLength(100)]],
      area: [data ? data.area : '', [Validators.maxLength(100)]],
      statusId: [data && data.statusId ? data.statusId : null]
    });
  }

  goToHotel() {
    this.employeeService.employeeDetails = this.employeeForm.value;
    this.router.navigate(['/hotel-management', 'hotel', 'add']);
  }

  ngOnInit() {
    this.getHotelsByHotelChain();
    this.getGenderSuffixes();
    this.initForm();
    this.previousRoute = this.utilService.getPreviousRoute;
    if(this.previousRoute.indexOf('/hotel/') > -1) {
      this.employeeDetails = this.employeeService.employeeDetails;
    } else {
      this.employeeService.employeeDetails = null;
      this.employeeDetails = null;
    }
    this.route.params.subscribe(params => {
      this.employeeId = +params['id']; // (+) converts string 'id' to a number
      this.employeeService.employeeId = this.employeeId;
      if(this.employeeId && !this.employeeDetails) {
        this.getEmployeeDetails(this.employeeId);
      } else {
        this.initForm(this.employeeDetails)
      }
    })
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();

  }

}



// WEBPACK FOOTER //
// ./src/app/components/admin/hca-admin/employees/employee-details/employee-details.component.ts